import Button from "@app/components/button";
import Checkbox from "@app/components/checkbox";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import Facebook from "@app/icons/facebook";
import { SignUpForm } from "@app/types";
import { signUpValidationSchema } from "@app/validations";
import { Images } from "@assets/images";
import { Environment } from "@environments/environment";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";
import {
  ReactFacebookFailureResponse,
  ReactFacebookLoginInfo,
} from "react-facebook-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { addToast } from "../toast/toast.service";
import { SystemMessage } from "@app/constants";

interface SignUpProps {
  onSwitchToSignIn: () => void;
  onSubmit: (values: SignUpForm) => void;
  onGoogleLoginSuccess: (credentialResponse: CredentialResponse) => void;
  onFacebookLoginSuccess: (
    userInfo: ReactFacebookLoginInfo | ReactFacebookFailureResponse
  ) => void;
}

function SignUp({
  onSwitchToSignIn,
  onSubmit,
  onGoogleLoginSuccess,
  onFacebookLoginSuccess,
}: SignUpProps) {
  const formRef = createRef<FormikContextType<SignUpForm>>();

  const onGoogleLoginError = () => {
    addToast({ text: SystemMessage.LOGIN_FAILED, status: "inValid" });
  };

  return (
    <div className="flex items-center justify-center">
      <div className="w-[600px] px-[34px] py-6 bg-white rounded-xl">
        <div className="flex justify-center">
          <img className="w-28" src={Images.LogoText.default} alt="" />
        </div>
        <div className="mt-4 font-[SVN-Gilroy] font-semibold text-xl text-center neutral-n80">
          Đăng ký tài khoản
        </div>
        <div className="mt-2 black-30 text-sm text-center black-30 font-[SVN-Gilroy] font-medium">
          Hãy điền thông tin tài khoản của bạn
        </div>
        <Formik
          innerRef={formRef}
          initialValues={{
            phone: "",
            email: "",
            fullName: "",
            password: "",
            confirmPassword: "",
            username: "",
            agree: [],
          }}
          onSubmit={onSubmit}
          validationSchema={signUpValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="flex items-center mt-[26px] justify-between gap-4">
              <div className="w-[50%]">
                <div>
                  <FormControl name="fullName">
                    <Input
                      placeholder="Họ và tên (*)"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl name="phone">
                    <Input
                      placeholder="Số điện thoại"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl name="email">
                    <Input
                      placeholder="Email (*)"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
              </div>
              <div className="w-[50%]">
                <div>
                  <FormControl name="username">
                    <Input
                      placeholder="Tên đăng nhập (*)"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl name="password">
                    <Input
                      type="password"
                      placeholder="Mật khẩu (*)"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl name="confirmPassword">
                    <Input
                      type="password"
                      placeholder="Nhập lại mật khẩu (*)"
                      inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                      errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div className="mt-4 flex">
              <FormControl name="agree">
                <Checkbox
                  label={
                    <p className="text-sm font-medium font-[SVN-Gilroy]">
                      <span className="text-[#333B47]">
                        Khi tham gia bạn đồng ý với{" "}
                      </span>
                      <a
                        className="text-[#4558ff] cursor-pointer font-[SVN-Gilroy] no-underline"
                        target="_blank"
                        href="https://bookas.vn/policies/"
                        rel="noreferrer"
                      >
                        chính sách riêng tư
                      </a>
                      <span className="text-[#333B47]"> và </span>
                      <a
                        className="text-[#4558ff] cursor-pointer font-[SVN-Gilroy] no-underline"
                        target="_blank"
                        href="https://bookas.vn/rules/"
                        rel="noreferrer"
                      >
                        điều khoản dịch vụ
                      </a>
                      <span className="text-[#333B47]"> của chúng tôi</span>
                    </p>
                  }
                  value="true"
                />
              </FormControl>
            </div>
            <p className="text-sm font-medium font-[SVN-Gilroy] mt-4 pl-7 text-[#333B47]">
              Khi hết thời gian gói đăng ký, bạn vẫn có thể tiếp tục sử dụng ứng
              dụng để truy cập và nghe không giới hạn kho sách miễn phí.
            </p>
            <Button
              type="submit"
              containerClassName="mt-6 mx-auto"
              label="Đăng ký"
              labelClassName="font-[SVN-Gilroy]"
              width=""
              size="l"
              className="text-lg font-bold px-11 rounded-3xl"
            />
            <div className="flex items-center justify-center my-4 px-10">
              <hr className="flex-1 border-t border-gray-300" />
              <span className="mx-2 text-gray-500 text-sm font-[SVN-Gilroy]">
                Or continue with
              </span>
              <hr className="flex-1 border-t border-gray-300" />
            </div>
            <div className="flex space-x-4 my-4 justify-center items-center">
              <FacebookLogin
                appId={Environment.FACEBOOK_APP_ID}
                fields="name,email,picture"
                callback={onFacebookLoginSuccess}
                render={({ onClick }) => (
                  <button
                    type="button"
                    className="flex items-center justify-center space-x-2 px-4 py-2 h-10 border border-gray-300 rounded-full text-gray-700 hover:bg-gray-100 w-[141px]"
                    onClick={onClick}
                  >
                    <Facebook />
                    <span className="font-[SVN-Gilroy] font-semibold text-[14px]">
                      Facebook
                    </span>
                  </button>
                )}
              />
              <GoogleLogin
                onSuccess={onGoogleLoginSuccess}
                onError={onGoogleLoginError}
                shape="pill"
                theme="outline"
                size="large"
                text="signin"
                width={141}
              />
            </div>
            <div className="text-center mt-3 text-sm font-medium font-[SVN-Gilroy] text-[#333B47]">
              Đã có tài khoản?{" "}
              <span
                className="text-[#5A82D7] cursor-pointer font-[SVN-Gilroy] font-semibold"
                onClick={onSwitchToSignIn}
              >
                Đăng nhập
              </span>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
}

export default SignUp;
